/* eslint-disable react-hooks/exhaustive-deps */
import { ReactNode, createContext, useEffect, useState } from "react";

import { useApi } from "@/hooks/useApi";
import { professionalMap } from "@/utils/mappings/professional";
import { transformData } from "@/utils/transformData";

type ProfessionalsWithRoleContextType = {
	professionals: Professional[];
};

type PatientContextProviderProps = {
	roles: string | string[];
	children: ReactNode;
};

export const ProfessionalsWithRoleContext = createContext({} as ProfessionalsWithRoleContextType);

export function ProfessionalsWithRoleContextProvider({
	roles,
	children,
}: PatientContextProviderProps) {
	const [professionals, setProfessionals] = useState<Professional[]>([]);
	const { api } = useApi();

	async function fetchProfessionals() {
		const allowedProfiles = Array.isArray(roles) ? roles : [roles];

		try {
			const { data } = await api.get("/surgical-center/professionals", {
				params: {
					profiles: allowedProfiles,
				},
			});

			if (data.length) {
				const transformedData = transformData<Professional[]>(data, professionalMap);
				setProfessionals(transformedData);
			}
		} catch (error) {
			console.error(error);
		}
	}

	useEffect(() => {
		fetchProfessionals();
	}, []);

	return (
		<ProfessionalsWithRoleContext.Provider value={{ professionals }}>
			{children}
		</ProfessionalsWithRoleContext.Provider>
	);
}
